module.exports = "https://img1.huilianyi.com/7/icon-didi.7ae8391a94.appcore.png";